// removed by extract-text-webpack-plugin
module.exports = {"container":"_3KhGz","titleContainer":"_3d-o-","title":"_2E7My","message":"_3lBx3","selectWrapper":"_2WMow"};


//////////////////
// WEBPACK FOOTER
// ./app/components/move-to-category/move-to-category.scss
// module id = 852
// module chunks = 3 4 5 6 7